/*eslint-disable*/
import React, { useState } from 'react'
import TitleBar from '../../components/titleBar/title_bar'
import { Button, Input } from 'semantic-ui-react'
import VendorTable from '../../components/mastersComponent/vendor/vendorTable'
// import VehicleTable from '../../components/mastersComponent/vehicles/vehicleTable'


function Vendor(params) {
    const [searchValue, setsearchValue] = useState('')
    const [agApi, setagApi] = useState('')
    let handleSearch = (e, data) => {
        setsearchValue(data.value)
    }
    let getInitialized = (prams) => {
        prams.api.sizeColumnsToFit()
        // console.log(prams.api)
        prams.api.paginationSetPageSize(Number(10))
        setagApi(prams.api)
    }
    let onBtExport = () => {
        agApi.exportDataAsExcel({});
        // console.log(agApi)
    }
    return (
        <React.Fragment>
            <div className="ag-theme-material agOver">
                <VendorTable handleSearch={handleSearch} onGridReady={getInitialized} searchValue={searchValue} />
            </div>
        </React.Fragment>
    )
}

export default Vendor
